import { render } from "./Historical_Sales.vue?vue&type=template&id=7061123a&scoped=true"
import script from "./Historical_Sales.vue?vue&type=script&lang=js"
export * from "./Historical_Sales.vue?vue&type=script&lang=js"

import "./Historical_Sales.vue?vue&type=style&index=0&id=7061123a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7061123a"]])

export default __exports__